module.exports = {
  adobe_api_key_missing: 'Derzeit können PDFs nicht angezeigt werden. Bitte kontaktiere deinen Administrator und teile ihm dieses Problem mit (Kein PDF-Schlüssel für Domain)',
  no_response: 'Keine Antwort vom Server, bitte lade die Seite neu.',
  delete_failed: 'Die Nachricht konnte nicht gelöscht werden.',
}
